import React from 'react';
import * as config from "../../app.config";

function EnvironmentBanner() {
    const env = config.APPENV;

    if (env === 'prod') return null; // Don't show in production  

    return (
        <div className='flex mx-auto justify-center items-center'>
            <div className='oval bg-yellow-200 text-red-600 p-10 font-extrabold text-center'>{env.toUpperCase()} Environment</div>

        </div>
    );
}
export default EnvironmentBanner;
